import React, { Component } from 'react'
import MembersTableContainer from '../containers/members_table_container' 
import MembersLeftSidebarContainer from '../containers/members_left_sidebar_container' 
import MembersSearchBarContainer from '../containers/members_search_bar_container' 
import FieldsContainer from '../containers/sidebar_content/fields_container'
import HandleFormatContainer from '../containers/sidebar_content/handle_format_container'
import { Col } from 'react-flexbox-grid'
import PropTypes from 'prop-types'
import AddGolfersManuallyContainer from '../containers/sidebar_content/add_golfers_manually_container'
import EditCustomFieldsContainer from '../containers/sidebar_content/edit_custom_fields_container'
import UploadSpreadsheetContainer from '../containers/sidebar_content/upload_spreadsheet_container'
import MembersAlertContainer from '../containers/members_alert_container'
import LeaguesPropagationPopupContainer from '../containers/propagation/leagues_propagation_popup_container'
import DeleteRosterConfirmationPopupContainer from '../containers/sidebar_content/delete_roster_confirmation_popup_container'
import RegisterMemberPopupContainer from '../containers/register_member/register_member_popup_container'

export class MembersPageComponent extends Component {
  constructor(props) {
    super(props)
  }
  
  componentDidMount(){
    this.props.fetchInitialMembersData()
    window.glg.member.initHandicapServerInfo(this.props.hsInfoLink)
  }
  
  render(){
    // const isLeftSidebarOpen = this.props.isSidebarOpen
    const showMembersAlert = this.props.modalChangeHandicapIndex || this.props.showInvalidEmailsMessage
    return (
      <div className={'league_' + this.props.leagueId} style={{display: 'flex', flex: '1 1 auto', flexDirection: 'row'}}>
        <div className='container_row row' style={{display: 'flex', flex: '1 1 auto', flexDirection: 'row'}}>
          <div style={{position: 'absolute', width: '100%', height: 'calc(100% - 125px)'}}>
            <Col className='no_padding left_sidebar' xs={1} sm={2} md={2} lg={1} style={{display: 'flex', flex: '1 1 auto', flexDirection: 'column'}}>
              <MembersLeftSidebarContainer {...this.props} />
            </Col>
            <Col id='left_sidebar_content' xs={11} sm={6} md={4} lg={3} className={'no_padding'} style={{display: this.props.isSidebarOpen ? 'flex' : 'none', position: 'relative'}}>
              { this.props.isOpen.fields && ( <FieldsContainer {...this.props} />) }
              { this.props.isOpen.handleFormat && ( <HandleFormatContainer />) }
              { this.props.isOpen.uploadSpreadsheet && ( <UploadSpreadsheetContainer {...this.props} />) }
            </Col>
          </div>
          <Col className='no_padding main-container' xs={11} xsOffset={1} smOffset={2} mdOffset={2} lgOffset={1}>
            {showMembersAlert && (
              <Col xs={12} style={{paddingLeft: 0, paddingTop: '15px'}}>
                <MembersAlertContainer />
              </Col>
            )}
            <Col className='search_bar add-padding-right-10' xs={12}>
              <MembersSearchBarContainer {...this.props} />
            </Col>
            <Col className='members_table_container_id bootstrap_members_table no_padding' xs={12} style={{display: 'flex', flex: '1 1 auto', flexDirection: 'column'}}>
              <MembersTableContainer {...this.props} />
            </Col>
          </Col>
        </div>
        <AddGolfersManuallyContainer {...this.props} />
        <EditCustomFieldsContainer />
        { this.props.isLeaguesPropagationPopupOpen && ( <LeaguesPropagationPopupContainer {...this.props} /> )}
        <DeleteRosterConfirmationPopupContainer />
        <RegisterMemberPopupContainer />
        {this.props.isGcatCustomer && (
          <div id='hs_info_content' className='hidden'></div>
        )}
      </div>
    )
  }
}

MembersPageComponent.propTypes = {
  isSidebarOpen: PropTypes.bool,
  leagueId: PropTypes.string.isRequired,
  canOpenMemberModal: PropTypes.bool.isRequired,
  fetchInitialMembersData: PropTypes.func.isRequired,
  openAddGolfersManuallyPopup: PropTypes.func.isRequired,
  openUploadSpreadsheetSidebar: PropTypes.func.isRequired,
  openRegisterMemberPopup: PropTypes.func.isRequired,
  getRegisterMemberData: PropTypes.func.isRequired,
  isOpen: PropTypes.object.isRequired,
  modalChangeHandicapIndex: PropTypes.bool.isRequired,
  isGcatCustomer: PropTypes.bool.isRequired,
  isLeaguesPropagationPopupOpen: PropTypes.bool.isRequired,
  showInvalidEmailsMessage: PropTypes.bool.isRequired,
  hsInfoLink: PropTypes.string,
  memberId: PropTypes.string,
  openOption: PropTypes.string,
}

export default MembersPageComponent